import React, { useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { 
  updateDocFileStatus, updateReviewerDocFileStatus, 
  setOutputFileAttribute, sendDocCancelEmail } from './thunks';
import { updateDocFileData } from './actions';
import 'bootstrap/dist/css/bootstrap.min.css';
import './NavDocSub.css';

const NavDocSub = ({ 
  mode, files, userInfo, groupInfo, reviewInfo, reviewAssignInfo,
  startUpdateDocFileStatus, startUpdateReviewerDocFileStatus, 
  startUpdateStatusByRB, startUpdateStatusByLP,
  startSetOutputFileAttribute, startSendDocCancelEmail, startUpdateDocFileData }) => {
  
  const [show, setShow] = useState(false);
  const [reason, setReason] = useState('');

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  
  const onSelectReviewStatus = (event) => {
    const reviewStatusId = parseInt(event.target.value);
    const filename = getSelectedFileName(files);
    // const fileStatusId = getSelectFileStatusId();
    // console.log('>>> onSelectReviewStatus', filename, reviewStatusId);
    // for status change to canceled (statusId == 2), show dialog for cancel reason
    if (reviewStatusId === 2) {
      console.log('>>> show cancel reason dialogbox');
      handleShow();
    }
    const reviewData = {
      program: reviewInfo.program,
      study: reviewInfo.study,
      milestone: reviewInfo.milestone,
      groupId: reviewInfo.groupId,
      userId: reviewInfo.user,
      filename: filename,
      statusId: reviewStatusId
    };
    // parameter: program, study, milestone, filename, statusId
    startUpdateDocFileStatus(reviewData);
    setTimeout(() => {
      startSetOutputFileAttribute({
        fileName: filename,
        isSelected: true, 
      })
    }, 350);
  }
  
  const sendCancellation = (event) => {
    // console.log('>>> sendCancellation reason:', reason);
    const filename = getSelectedFileName(files);
    startSendDocCancelEmail({ 
      emailData: { title:'', content:'' }, 
      filename: filename,
      reviewInfo: reviewInfo,
      groupInfo: groupInfo,
      reviewers: reviewAssignInfo.reviewers,
      cancelReason: reason,
    });
    const reviewData = {
      program: reviewInfo.program,
      study: reviewInfo.study,
      milestone: reviewInfo.milestone,
      groupId: reviewInfo.groupId,
      userId: reviewInfo.user,
      filename: filename,
      cancelReason: reason,
    };
    // parameter: program, study, milestone, filename, statusId
    startUpdateDocFileStatus(reviewData);
    handleClose();
  }
  
  const onPagesReviewedChange = (event) => {
    const pagesReviewed = parseInt(event.target.value);
    const filename = getSelectedFileName(files);
    // console.log('>>> onPagesReviewedChange:', filename, pagesReviewed);
    const docFileData = {
      program: reviewInfo.program,
      study: reviewInfo.study,
      milestone: reviewInfo.milestone,
      groupId: reviewInfo.groupId,
      userId: reviewInfo.user,
      filename: filename,
      pagesReviewed: pagesReviewed,
    };
    // update reviewer doc status/data 
    startUpdateReviewerDocFileStatus(docFileData);
    startUpdateDocFileData({
      filename: filename,
      pagesReviewed: pagesReviewed,
    });
    setTimeout(() => {
      startSetOutputFileAttribute({
        fileName: filename,
        isSelected: true, 
      })
    }, 350);
  }
  
  const getSelectedFileName = (files) => {
    const [selectedFile] = files.filter( file => file.isSelected );
    return selectedFile && selectedFile.fileName;
  }
  
  const getSelectedFileTotalPageRange = (files) => {
    const [selectedFile] = files.filter( file => file.isSelected );
    let totalPages = selectedFile && selectedFile.pagesTotal;
    if (totalPages > 0) {
      totalPages = totalPages + 1;
    } else {
      totalPages = 0;
    }
    return totalPages;
  }
  
  const getSelectFileStatusId = () => {
    let statusId = 0;
    const [selectedFile] = files.filter( file => file && file.isSelected );
    if (selectedFile) {
      statusId = selectedFile.statusId || 0;
    }
    // console.log('>>> getSelectFileStatusId statusId:', statusId);
    return statusId;
  }
  
  const getSelectFilePagesReviewed = () => {
    let pagesReviewed = 0;
    const [selectedFile] = files.filter( file => file && file.isSelected );
    if (selectedFile) {
      pagesReviewed = selectedFile.pagesReviewed || 0;
    }
    return pagesReviewed;
  }
  
  const getSelectFileStatus = () => {
    let fileStatus = '';
    const [selectedFile] = files.filter( file => file && file.isSelected );
    if (selectedFile) {
      let status = _.filter(userInfo.reviewStatus, { display_order:selectedFile.statusId });
      fileStatus = status && status[0] && status[0].code_value;
    }
    return fileStatus;
  }
  
  return (
    <div className="NavDocSub">
      <Container fluid>
        <Row>
          <Col md={3} className="">
            <div className="subtitle">Document Review</div>
          </Col>
          
          <Col md={9} className="">
            <Form inline className="formInline">
              { mode === "admin" ?
              <Form.Group controlId="reviewStatusSelect">
                <Form.Label className="reviewStatusSelectLabel">Review Status</Form.Label>
                <Form.Control as="select" size="sm" onChange={onSelectReviewStatus} 
                  value={getSelectFileStatusId()} >
                  <option key='0' value='' ></option>
                  {userInfo.reviewStatus.map((statusItem, index) => (
                    <option key={statusItem.display_order} value={statusItem.display_order} >
                      {statusItem.code_value}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
              : ""}
              { mode === "review" ?
              <Form.Group controlId="pagesReviewed">
                <Form.Label>Number of Pages Reviewed</Form.Label>
                <Form.Control as="select" size="sm" onChange={onPagesReviewedChange} 
                  value={getSelectFilePagesReviewed()} >
                  {_.range(getSelectedFileTotalPageRange(files)).map((number) => (
                    <option key={number} value={number} >
                      {number}
                    </option>
                  ))}
                </Form.Control>
                <Form.Label>Status: {getSelectFileStatus()}</Form.Label>
              </Form.Group>
              : ""}
            </Form>
          </Col>
        </Row>
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false} >
          <Modal.Header closeButton>
            <Modal.Title>Cancel Review</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="cancelReason">
              <Form.Label>Reason for Cancelling this review</Form.Label>
              <Form.Control type="text" size="sm" value={reason}
                onChange={(event) => setReason(event.target.value)} />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={sendCancellation}>Send Cancellation</Button>
            <Button variant="secondary" onClick={handleClose}>Cancel</Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
}

const mapState = state => ({
  files: state.files,
  userInfo: state.userInfo,
  groupInfo: state.groupInfo,
  reviewInfo: state.reviewInfo,
  reviewAssignInfo: state.reviewAssignInfo,
})

const mapDispatch = dispatch => ({
  startUpdateDocFileStatus: (data) => dispatch(updateDocFileStatus(data)),
  startUpdateDocFileData: (data) => dispatch(updateDocFileData(data)),
  startUpdateReviewerDocFileStatus: (data) => dispatch(updateReviewerDocFileStatus(data)),
  startSetOutputFileAttribute: (data) => dispatch(setOutputFileAttribute(data)),
  startSendDocCancelEmail: (data) => dispatch(sendDocCancelEmail(data)),
})

export default connect(mapState, mapDispatch)(NavDocSub);
